import React from "react";
import { forgotPassword } from "../../api/auth";

export default function ForgotPasswordForm({ logoUrl, onBack }) {
  const [email, setEmail] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      await forgotPassword(email.trim());
      setSubmitted(true);
    } catch (error) {
      console.error(error);
      setErrorMessage("Unable to send reset email right now. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <section className="auth-card" aria-labelledby="forgot-title">
        <div className="auth-branding">
          <img className="auth-logo" src={logoUrl} alt="Meditec Staffing Company" />
          <h1 id="forgot-title">Reset password</h1>
        </div>

        {submitted ? (
          <div className="auth-confirm" role="status">
            <div className="auth-confirm-icon" aria-hidden="true">✓</div>
            <p className="auth-confirm-title">Check your email</p>
            <p className="auth-confirm-body">If that address is on file, we sent a password reset link to:</p>
            <p className="auth-confirm-email">{email}</p>
            <p className="auth-confirm-body">Open the email and follow the link to reset your password.</p>
            <p className="auth-confirm-hint">Didn&rsquo;t receive it? Check your spam folder or wait a few minutes.</p>
            <button type="button" className="auth-back-link" onClick={onBack}>
              Back to sign in
            </button>
          </div>
        ) : (
          <>
            <p className="auth-help-text">
              Enter your email to receive a password reset link.
            </p>

            <form className="auth-form" onSubmit={handleSubmit}>
              <label className="field" htmlFor="forgot-email">
                <span>Email Address</span>
                <input
                  id="forgot-email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  disabled={isSubmitting}
                />
              </label>

              <button type="submit" className="primary-action auth-submit" disabled={isSubmitting || !email.trim()}>
                {isSubmitting ? "Sending..." : "Send reset link"}
              </button>

              <button type="button" className="auth-back-link" onClick={onBack} disabled={isSubmitting}>
                Back to sign in
              </button>
            </form>
          </>
        )}

        {errorMessage ? (
          <div className="status-message error" role="alert">
            {errorMessage}
          </div>
        ) : null}
      </section>
    </div>
  );
}
